export default __webpack_public_path__ + "static/media/rocket_anim_94.e9f7b1f2.png";